// Vor dem ersten Foto: Hinweis zu KI-Auswertung, Löschfrist und was nicht
// fotografiert werden soll, mit Bestätigung (Zeitpunkt am Server).

import { useState } from "react";
import { DATENSCHUTZ_URL, PHOTO_NOTICE_LABEL, photoNoticeText } from "@umzugsscan/shared";
import { useDraft, useStore } from "../hooks.ts";
import { Check, Footer } from "./elemente.tsx";

export function Fotohinweis(props: { onBack: () => void }) {
  const d = useDraft();
  const store = useStore();
  const [ack, setAck] = useState(false);
  const [ackTried, setAckTried] = useState(false);
  return (
    <>
      <h1>Bevor Sie fotografieren</h1>
      <section className="card">
        {photoNoticeText(d.company.photoRetentionDays ?? 90).map((t) => (
          <p key={t}>{t}</p>
        ))}
        <p className="hint">
          Einzelheiten in der{" "}
          <a href={DATENSCHUTZ_URL} target="_blank" rel="noopener">
            Datenschutzerklärung
          </a>
          .
        </p>
        <Check checked={ack} onChange={setAck}>
          {PHOTO_NOTICE_LABEL}
        </Check>
        {ackTried && !ack && <p className="error">Bitte bestätigen Sie den Hinweis.</p>}
      </section>
      <Footer
        onBack={props.onBack}
        nextLabel="Zu den Fotos"
        onNext={() => {
          setAckTried(true);
          if (ack) store.updateSurvey({ photoNotice: true });
        }}
      />
    </>
  );
}
